import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const SUPPORTED_LANGUAGE_CODES = ['en', 'de', 'ro', 'sv', 'no'] as const;
export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGE_CODES)[number];

// Keep in sync with libs/domain/src/i18n/constants.ts on the backend.
export const DEFAULT_LANGUAGE_CODE: SupportedLanguageCode = 'de';

export const LANGUAGE_NATIVE_NAMES: Record<SupportedLanguageCode, string> = {
  de: 'Deutsch',
  en: 'English',
  no: 'Norsk',
  ro: 'Română',
  sv: 'Svenska',
};

export function isSupportedLanguageCode(
  code: string | undefined | null,
): code is SupportedLanguageCode {
  return (
    !!code && (SUPPORTED_LANGUAGE_CODES as readonly string[]).includes(code)
  );
}

export function resolveBrowserLanguageCode(): SupportedLanguageCode {
  const browserLanguages = navigator.languages ?? [navigator.language];
  for (const browserLanguage of browserLanguages) {
    const code = browserLanguage.split('-')[0]?.toLowerCase();
    if (isSupportedLanguageCode(code)) {
      return code;
    }
  }
  return DEFAULT_LANGUAGE_CODE;
}

// Resources start empty - loadLanguage fetches each bundle from the DB on demand.
void i18n.use(initReactI18next).init({
  fallbackLng: DEFAULT_LANGUAGE_CODE,
  interpolation: { escapeValue: false },
  lng: DEFAULT_LANGUAGE_CODE,
  resources: {},
});

export default i18n;
